// extracted by mini-css-extract-plugin
export var isChunked = "QuestionList-module--isChunked--c0012";
export var link = "QuestionList-module--link--d73f2";
export var list = "QuestionList-module--list--9d580";